import { useLocation } from 'react-router-dom';
import T from '@wojtekmaj/react-t';

import { stringify } from '@rewardopl/utils/url';

import { Button, Icon } from './login_with_apple_button.styles';

import appleIcon from '../../../../static/apple.svg';

export default function LoginWithAppleButton() {
  const location = useLocation();

  const { returnPath = '/' } = (location.state || {}) as {
    returnPath?: string;
  };

  const href = `/api/auth/apple${stringify({
    state: encodeURIComponent(JSON.stringify({ mobile: false, returnPath })),
  })}`;

  return (
    <Button as="a" href={href}>
      <Icon alt="Apple" height={20} src={appleIcon} width={20} />
      <T>Sign in with Apple</T>
    </Button>
  );
}
